const getters = {
    vipFlag: state => state.app.vipFlag,
};

export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js